import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { toggleBubbleOpen, trackButtonName } from 'store/onboarding';

// UI
import AppBar from '@material-ui/core/AppBar';
import PersonMenu from '@sift/skipper/components/appBar/PersonMenu';
import OnboardingListButton from 'components/AppHeader/OnboardingListButton';
import OnboardingTaskButton from 'components/AppHeader/OnboardingTaskButton';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

function AppHeader({ person, classes, pictureUrl }) {
  const dispatch = useDispatch();
  const analytics = useAnalytics();

  const onboardingState = useSelector(state => state.onboarding);

  const { bubbleOpen, buttonName } = onboardingState;

  const handleOnboardingButtonClick = _buttonName => {
    if (buttonName === _buttonName) {
      dispatch(toggleBubbleOpen(false));
      dispatch(trackButtonName(null));
    } else {
      dispatch(trackButtonName(_buttonName));

      if (!bubbleOpen) {
        dispatch(toggleBubbleOpen(true));
        analytics.track('Onboarding Overlay opened', {
          category: 'AD - Onboarding',
        });
      }
    }
  };

  const avatarHeader = person.id ? (
    <PersonMenu
      classes={{
        name: classes.name,
        root: classes.personMenuRoot,
        icon: classes.personMenuIcon,
      }}
      person={person}
      pictureUrl={pictureUrl}
    />
  ) : null;

  return (
    <AppBar classes={{ root: classes.root }} elevation={1}>
      <div className={classes.navigation}>
        <OnboardingTaskButton onOnboardingButtonClick={handleOnboardingButtonClick} />
        <OnboardingListButton onOnboardingButtonClick={handleOnboardingButtonClick} />
        {avatarHeader}
      </div>
    </AppBar>
  );
}

AppHeader.propTypes = {
  person: PropTypes.object,
  pictureUrl: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

const styles = theme => {
  return {
    root: {
      width: `calc(100% - ${theme.overrides.AppSidebar.width}px)`,
      marginLeft: theme.overrides.AppSidebar.width,
      fontSize: 18,
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      zIndex: theme.zIndex.surface,
      background: theme.palette.common.white,
      color: '#000',
      boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    },
    personMenuRoot: {
      minHeight: 64,
      maxHeight: 64,
      marginRight: 20,
    },
    personMenuIcon: {
      color: '#000 !important',
    },
    navigation: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    link: {
      textDecoration: 'none',
    },
    name: {
      color: '#000',
    },
  };
};

export default withStyles(styles)(AppHeader);
